<div *ngIf="data">
  <div class="container-fluid p-0 print-width px-3  py-3">
    <div class="row mb-2">
      <div class="col header-text">
        <span>TICKET</span>
      </div>
    </div>
    <div class="row">
      <span>
        {{ datas[0].betSlip.raceTrack }} - {{ "RACES.R" | translate
        }}{{ datas[0]?.betSlip?.raceIndex }}
        <span class="ml-3" *ngIf="betTime">{{ betTime }}</span>
      </span>
    </div>

    <div class="row">
      <span class="mr-2 p-0">{{ "RACES.DATE" | translate }}: </span>
      <span *ngIf="!datas[0].coupon.Id">{{ datas[0].coupon.createdAt | date: "dd-MM-yyyy - HH:mm:ss" }}
      </span>
      <span *ngIf="datas[0].coupon.Id">{{ datas[0].betSlip.raceScheduleTimeUtc }}
      </span>
    </div>

    <ng-container *ngFor="let data of datas">

      <div class="row bottom-border pb-2 mt-5">
        <span class="mr-2 p-0">{{ "RACES.COMBINAISON" | translate }}: </span>
        <span>{{
          data.betSlip.bet
          | bettingType: data?.raceDetail?.Country
          | translate
          | capitalizeFirst
          }}</span>
      </div>

      <div class="row bottom-border py-2">
        <span class="columnTitle">{{ "RACES.MARKINGS" | translate }}</span>
        <ng-container *ngIf="data.betSlip.bet === 'exacta'">
          <div *ngIf="getRunnerofBetData(data,1).length > 0" class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">I</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data,1); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
          <div *ngIf="getRunnerofBetData(data,2).length > 0" class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">II</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data,2); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
          <div *ngIf="getRunnerofBetData(data,5).length > 0" class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">K</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data,5); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="data.betSlip.bet === 'quinella'">
          <div *ngIf="getRunnerofBetData(data,1)[0]" class="bets-row mb-0">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">I</span><span>:</span>
              </span>
            </div>
            <div>
              <span> {{ getRunnerofBetData(data,1)[0].runnerProgramNumber }}</span>
            </div>
          </div>
          <div class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">K</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data,2); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="
          data.betSlip.bet === 'trifecta' ||
          data.betSlip.bet === 'pmu_tierce' ||
          data.betSlip.bet === 'pmu_super_4' ||
          data.betSlip.bet === 'pmu_quarte_plus'
        ">
          <div *ngIf="getRunnerofBetData(data,1).length > 0" class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">I</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data,1); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
          <div *ngIf="getRunnerofBetData(data,2).length > 0" class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">II</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data,2); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
          <div *ngIf="getRunnerofBetData(data,3).length > 0" class="mb-0 bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">III</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data,3); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
          <div *ngIf="getRunnerofBetData(data,4).length > 0" class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">IV</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data,4); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
          <div *ngIf="getRunnerofBetData(data, 5).length > 0" class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">K</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data, 5); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="
        data.betSlip.bet === 'pmu_quinte_plus'
      ">
          <div *ngIf="getRunnerofBetData(data, 1).length > 0" class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">I</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data, 1); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
          <div *ngIf="getRunnerofBetData(data,2).length > 0" class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">II</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data, 2); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
          <div *ngIf="getRunnerofBetData(data,3).length > 0" class="mb-0 bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">III</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data, 3); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
          <div *ngIf="getRunnerofBetData(data,4).length > 0" class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">IV</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data,4); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>

          <div *ngIf="getRunnerofBetData(data,5).length > 0" class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">V</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data,5); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
          <div *ngIf="getRunnerofBetData(data,6).length > 0" class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">K</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data,6); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="data.betSlip.bet === 'trio'">
          <div *ngIf="getRunnerofBetData(data,1).length > 0" class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">I</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data,1); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
          <div *ngIf="getRunnerofBetData(data,2).length > 0" class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">II</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data,2); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
          <div *ngIf="getRunnerofBetData(data,5).length > 0" class="bets-row">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">K</span><span>:</span>
              </span>
            </div>
            <div>
              <span *ngFor="let bet of getRunnerofBetData(data,5); let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="
          data.betSlip.bet !== 'exacta' &&
          data.betSlip.bet !== 'quinella' &&
          data.betSlip.bet !== 'trifecta' &&
          data.betSlip.bet !== 'pmu_super_4' &&
          data.betSlip.bet !== 'pmu_quarte_plus' &&
          data.betSlip.bet !== 'pmu_quinte_plus' &&
          data.betSlip.bet !== 'pmu_tierce' &&
          data.betSlip.bet !== 'trio'
        ">
          <div class="bets-row w-100">
            <div>
              <span class="d-flex">
                <span class="font-weight-bold bet-rank-icon text-center border">{{
                  data.betSlip.bet | legSelection
                  }}</span><span>:</span>
              </span>
              <!-- <span class="font-weight-bold bet-rank-icon text-center border">{{data.betSlip.bet | legSelection}}</span>: -->
            </div>
            <div>
              <span *ngFor="let bet of data.betSlip.bets; let isLast = last">
                {{ bet.runnerProgramNumber }}{{ isLast ? "" : "," }}</span>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="row pb-1 pt-2">
        <span class="mr-2">{{ "RACES.STAKE" | translate }}: </span>
        <span>{{ data.betSlip.stake * 1 | number: "1.2-2" }} {{authService.currentCurrency$ | async | uppercase}}</span>
      </div>

      <div class="row bottom-border pb-2">
        <span class="mr-2">{{ "RACES.NUMBER_OF_BETS" | translate }}: </span>
        <span>{{
          (data.betSlip.totalPrice * 1) / (data.betSlip.stake * 1)
          }}</span>
      </div>

      <div class="row mb-2 pb-2 pt-2 bottom-border">
        <div class="col-4 p-0">{{ "RACES.TOTAL" | translate }}</div>
        <div class="col-8 p-0">
          <strong>
            {{ data.betSlip.totalPrice * 1 | number: "1.2-2" }} {{authService.currentCurrency$ | async |
            uppercase}}</strong>
        </div>
      </div>

      <div class="row mb-2 pb-2 pt-2 bottom-border">
        <div class="col-4 p-0">{{ "RACES.STATUS" | translate }}</div>
        <div class="col-8 p-0">
          <strong>
            <strong>
              {{ "RACES." + data.coupon.status | uppercase | translate }}
            </strong></strong>
        </div>
        <ng-container *ngIf="data.betSlip.winnings">
          <div class="col-4 p-0">{{ "RACES.WINNINGS" | translate }}</div>
          <div class="col-8 p-0">
            <strong>
              {{ data.betSlip.winnings | number: "1.2-2" }} {{authService.currentCurrency$ | async |
              uppercase}}</strong>
          </div>
        </ng-container>
      </div>

      <div class="row text-center">
        <ngx-barcode [bc-value]="data.coupon.betSlipId" [bc-display-value]="false" [bc-font-size]="10"
          [bc-element-type]="'img'">
        </ngx-barcode>
        <span class="d-flex justify-content-center w-100">{{
          data.coupon.betSlipId
          }}</span>
        <!-- [bc-width]="1" [bc-height]="50" -->
      </div>
    </ng-container>
  </div>

</div>